// please be familiar with react-bootstrap-table-next column formaters
// https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html?selectedKind=Work%20on%20Columns&selectedStory=Column%20Formatter&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
// import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { SRLWrapper } from "simple-react-lightbox";
import Image from 'react-bootstrap/Image';

const options = {
	settings: {
	},
	buttons: {
		showAutoplayButton: false,
		showThumbnailsButton: false
	},
	caption: {
	},
	thumbnails: {
    	showThumbnails: false
	}
};

export function ImageColumnFormatter(cellContent, row) {
	return (
		<>
			<SRLWrapper options={options}>
      			<a href={ toAbsoluteUrl('api/app/' + row.img) }>
					<Image width="80" src={ toAbsoluteUrl('api/app/' + row.img) } rounded />
				</a>
			</SRLWrapper>	
		</>
	);
}
